/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */

const log = (logLevel: 'log' | 'debug' | 'warn' | 'info' | 'error') => (...args: any) => console[logLevel](...args);

const debug = log('debug');
const info = log('info');
const warn = log('warn');
const error = log('error');

export {
  debug,
  info,
  warn,
  error,
};
